import { useRouter } from 'next/router';
import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { actions } from 'store';
import { ConfirmButton } from 'components/common';

interface Props {
  isPathPage?: boolean;
  pathId: number;
  pathAvailable?: boolean;
  pathTitle: string;
  updatePath?: () => Promise<void>;
}

const PathsTileJoinPath = ({
  isPathPage = false,
  pathId,
  pathAvailable = true,
  pathTitle,
  updatePath
}: Props) => {
  const { dispatch } = useDispatch();

  const { messages } = useReduxState();

  const router = useRouter();

  const handleJoinPath = async () => {
    await api.post(`/admin/paths/${pathId}/join`);

    if (isPathPage) {
      await updatePath();
    } else {
      router.push(`/paths/${pathId}`);
    }

    return true;
  };

  if (!pathId || !pathAvailable) return null;

  return (
    <>
      <ConfirmButton
        actionText={messages.commonJoin}
        buttonIsRounded={true}
        buttonSize="small"
        buttonText={isPathPage ? messages.pathsJoinPath : messages.commonJoin}
        category={isPathPage ? 'success' : 'default'}
        confirmText={`${messages.pathsJoinPathConfirm} ${pathTitle}?`}
        confirmTitle={messages.pathsJoinPath}
        onConfirm={handleJoinPath}
        stopPropagation={true}
        successMessage={messages.pathsJoinPathSuccess}
      />
    </>
  );
};

export default PathsTileJoinPath;
